var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('p',{staticStyle:{"padding":"30px","color":"white"}},[_c('a',{attrs:{"href":"grp://restaurants.gastroranking.pro"}},[_vm._v("Open GastroRanking PRO")])])
}]

export { render, staticRenderFns }